module.exports = __webpack_public_path__ + "img/Hypoxia-NPC_GSE200310.6570959e.png";